import React from 'react';

const actions = [
  { id: 1, title: '📢 Post a Signal', bg: 'bg-blue-100', link: '#' },
  { id: 2, title: '👷 Hire a Freelancer', bg: 'bg-green-100', link: '#' },
  { id: 3, title: '📝 Create Job Listing', bg: 'bg-yellow-100', link: '#' },
  { id: 4, title: '📤 Submit Portfolio', bg: 'bg-purple-100', link: '#' },
];

export default function QuickActions() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {actions.map((action) => (
        <a
          key={action.id}
          href={action.link}
          className={`${action.bg} p-4 rounded-lg text-sm font-semibold text-gray-800 shadow hover:shadow-md hover:scale-105 transition`}
        >
          {action.title}
        </a>
      ))}
    </div>
  );
}
